// Track custom events across analytics providers (PostHog, Mixpanel, Plausible).
// GA and Umami are loaded via GTM; use lib/track.ts for conversion events that go to dataLayer + PostHog.

export const trackEvent = (eventName: string, params: Record<string, unknown> = {}) => {
  // PostHog
  if (typeof window !== 'undefined' && (window as Window & { posthog?: { capture: (e: string, p?: Record<string, unknown>) => void } }).posthog) {
    (window as Window & { posthog?: { capture: (e: string, p?: Record<string, unknown>) => void } }).posthog?.capture(eventName, params);
  }

  // Mixpanel
  if (typeof window !== 'undefined' && (window as Window & { mixpanel?: { track: (e: string, p?: Record<string, unknown>) => void } }).mixpanel) {
    (window as Window & { mixpanel?: { track: (e: string, p?: Record<string, unknown>) => void } }).mixpanel?.track(eventName, params);
  }

  // Plausible (if loaded via GTM)
  if (typeof window !== 'undefined' && (window as Window & { plausible?: (e: string, o?: { props?: Record<string, unknown> }) => void }).plausible) {
    (window as Window & { plausible?: (e: string, o?: { props?: Record<string, unknown> }) => void }).plausible?.(eventName, { props: params });
  }
};
